<template>
  <el-card>
    <el-tabs type="border-card" @tab-click="TabClick">
      <userManage> </userManage>

      <RolesManage> </RolesManage>

      <FunctionsManage> </FunctionsManage>

      <GroupsManage> </GroupsManage>

      <TeamsManage> </TeamsManage>
    </el-tabs>
  </el-card>
</template>

<script setup>
import { ref } from 'vue';
import TeamsManage from './teamsManage.vue';
import GroupsManage from './groupsManage.vue';
import FunctionsManage from './functionsManage.vue';
import RolesManage from './rolesManage.vue';
import userManage from './userManage.vue';

const tabkey = ref('UserManage');

const TabClick = (data) => {
  tabkey.value = data.props.label;
  console.log(data.props.label);
};
</script>

